import { STORE_SITE, STORE_SITE_ERROR, LOADING_SITE } from "../actions/types";
const initialState = {
    site: null,
    siteError: null,
    isLoadingSite: false,
};
export default function siteReducer(state = initialState, action) {
    switch (action.type) {
        case STORE_SITE:
            return {
                ...state,
                isLoadingSite: false,
                site: action.payload,
                siteError: null,
            };
        case LOADING_SITE:
            return {
                ...state,
                isLoadingSite: true,
                site: null,
                siteError: null,
            };
        case STORE_SITE_ERROR:
            return {
                ...state,
                isLoadingSite: false,
                siteError: action.payload,
                site: null,
            };
        default:
            return state;
    }
}